// extracted by mini-css-extract-plugin
export default {"container":"CookieMessage__container--16Q","wc":"CookieMessage__wc--2z9","common":"CookieMessage__common--1ie"};